import { SKU_TYPE } from '../../constants';
import { ref, Ref, computed } from 'vue';

export function useTab(isPersonal: Ref<Boolean>) {
  const activeTab = ref(SKU_TYPE.VIP);
  function handleActiveTab(v: SKU_TYPE) {
    activeTab.value = v;
  }
  const tabs = computed(() => [
    {
      title: isPersonal.value ? '购买个人会员' : '购买团队会员',
      value: SKU_TYPE.VIP,
    },
    {
      title: '购买灵豆',
      value: SKU_TYPE.PURCHASE,
    },
  ]);

  return {
    activeTab,
    handleActiveTab,
    tabs,
  };
}
